// extracted by mini-css-extract-plugin
module.exports = {"tab":"_3faIG5XD","tabsHeader":"k7bwBhKl","activeTab":"_2E94SYrm","disabledTab":"oTRPSuSY"};